module.exports = __webpack_public_path__ + "static/HKGrotesk-Light-37bfc5a7a23a3cf29c0e7bf04ea6c2c3.ttf";